import { Measure } from 'services/model/model.service';
import { createMeasureCell } from 'components/table/DataTableUtil';
import { GenericMeasureCellContext } from 'components/table/useDataEntriesInTables';

export function MeasureCell({
  measure,
  context,
  signedValue = false,
  comparisonActive = true,
  className = undefined,
}: {
  measure: Measure;
  context: GenericMeasureCellContext;
  className?: string;
  signedValue?: boolean;
  comparisonActive?: boolean;
}) {
  return <span className={className}>{createMeasureCell(context, measure, signedValue, comparisonActive)}</span>;
}
